import groupService from 'src/services/api/groupService';

export const fetchGroupAttendant = ({
  inputs,
  identification,
  phone,
  activityName,
  captcha,
  captchaRequired,
}) =>
  groupService.getGroupAttendant({
    ...inputs,
    identification,
    phone,
    activityName,
    ...(captchaRequired ? { captcha } : {}),
  });
